export interface RhtpAward {
  amount: number;
  label: string;
  source: string;
  retrievedOn: string;
}

export interface RhtpAnnouncement {
  date: string;
  amount: number;
  initiative: string;
  to: string;
}

export interface RhtpInitiative {
  key: string;
  name: string;
  lead: string;
  bp1: number;
  what: string;
}

export interface RhtpMilestone {
  date: string;
  label: string;
  note?: string;
}

export const award: RhtpAward = {
  amount: 188892439.75,
  label: "$188.9M",
  source:
    "CMS award announcement, 29 December 2025; Office of the Governor, 6 January 2026",
  retrievedOn: "2026-09-10",
};

export const announced: RhtpAnnouncement[] = [
  {
    date: "2026-09-01",
    amount: 45000000,
    initiative: "HOME RUN",
    to: "JABSOM, workforce education and training awards",
  },
  {
    date: "2026-09-01",
    amount: 13000000,
    initiative: "RICA",
    to: "Department of Health, ambulances and emergency communications",
  },
];

export const announcedSource = "Office of the Governor release, 1 September 2026";

export const initiatives: RhtpInitiative[] = [
  {
    key: "RICA",
    name: "Rural Infrastructure for Care Access",
    lead: "Department of Health",
    bp1: 53000000,
    what: "Statewide medical communications center; mobile integrated health and community paramedicine; technology-enabled vehicles including mobile clinics and mobile dialysis; behavioral health crisis access",
  },
  {
    key: "RHIN",
    name: "Rural Health Information Network",
    lead: "SHPDA",
    bp1: 45400000,
    what: "Interoperable EHRs, infrastructure and security, health information exchange, care coordination tools",
  },
  {
    key: "HOME RUN",
    name: "Workforce",
    lead: "JABSOM",
    bp1: 45000000,
    what: "Education and training awards with a five-year rural service commitment; nurse residencies; a target of 1,000 new rural health workers",
  },
  {
    key: "RVBI",
    name: "Rural Value-Based Innovation and AHEAD Readiness",
    lead: "SHPDA",
    bp1: 25000000,
    what: "Readiness infrastructure, advanced primary care, hospital global-budget readiness, aligned with AHEAD",
  },
  {
    key: "Pili Ola",
    name: "Telehealth",
    lead: "UH Mānoa",
    bp1: 12500000,
    what: "Remote monitoring, employer and school-based access points, behavioral health, maternal care, e-consults",
  },
  {
    key: "RRN",
    name: "Rural Respite Network",
    lead: "Department of Human Services",
    bp1: 3200000,
    what: "Medical respite beds; Kauaʻi and Hilo first",
  },
];

export const initiativesSource =
  "Hawaiʻi Rural Health Transformation Program briefing, September 2026";

export const initiativesNote =
  "Initiative allocations sum to $184.1M; a program oversight team holds $4.5M";

export const milestones: RhtpMilestone[] = [
  {
    date: "2026-10-30",
    label: "Budget Period 1 obligation deadline",
    note: "as reported in the state briefing",
  },
  {
    date: "2027-01-01",
    label: "CMS-0057-F prior authorization API compliance date",
  },
  { date: "2027-01-20", label: "Hawaiʻi Legislature convenes" },
  { date: "2027-09-30", label: "Budget Period 1 expenditure window closes" },
];

export const lastChecked = "2026-09-15";
